import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { produce } from 'immer'

import {
  FacebookPageStatistic,
  InstagramPageStatistic,
} from '@3m5/sm_publish-frontend-api/models/index'

import { ApiError } from '../../store/statisticsRoot.reducer'

import {
  getFacebookPageStatistics, getFacebookPostsInRangeForPage, getInstagramPageStatistics, getInstagramPostsInRangeForPage,
} from './statistics.user.actions'
import { FacebookPostWithRelativeReach, InstagramPostWithRelativeReach } from '@3m5/sm_publish-frontend-api/models'

export interface StatisticsUserState {
  fetching: boolean
  facebookPageStatistics?: FacebookPageStatistic[]
  instagramPageStatistics?: InstagramPageStatistic[]
  facebookPostsInRange?: FacebookPostWithRelativeReach[]
  instagramPostsInRange?: InstagramPostWithRelativeReach[]
  error: ApiError
}

const INITIAL_STATE: StatisticsUserState = {
  fetching: false,
  error: {},
}

export const StatisticsUserReducer = reducerWithInitialState(INITIAL_STATE)
  /**
   * getFacebookPageStatistics
   */
  .case(getFacebookPageStatistics.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.getFacebookPageStatistics
    })
  })

  .case(getFacebookPageStatistics.done, (state, { result }) => {
    return produce(state, draft => {
      draft.facebookPageStatistics = result
      draft.fetching = false
    })
  })

  .case(getFacebookPageStatistics.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.getFacebookPageStatistics = (error as Response)
    })
  })

  /**
   * getInstagramPageStatistics
   */
  .case(getInstagramPageStatistics.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.getInstagramPageStatistics
    })
  })

  .case(getInstagramPageStatistics.done, (state, { result }) => {
    return produce(state, draft => {
      draft.instagramPageStatistics = result
      draft.fetching = false
    })
  })

  .case(getInstagramPageStatistics.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.getInstagramPageStatistics = (error as Response)
    })
  })

  /**
   * getFacebookPostsInRangeForPage
   */
  .case(getFacebookPostsInRangeForPage.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.getFacebookPostsInRangeForPage
    })
  })

  .case(getFacebookPostsInRangeForPage.done, (state, { result }) => {
    return produce(state, draft => {
      draft.facebookPostsInRange = result
      draft.fetching = false
    })
  })

  .case(getFacebookPostsInRangeForPage.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.getFacebookPostsInRangeForPage = (error as Response)
    })
  })

  /**
   * getInstagramPostsInRangeForPage
   */
  .case(getInstagramPostsInRangeForPage.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.getInstagramPostsInRangeForPage
    })
  })

  .case(getInstagramPostsInRangeForPage.done, (state, { result }) => {
    return produce(state, draft => {
      draft.instagramPostsInRange = result
      draft.fetching = false
    })
  })

  .case(getInstagramPostsInRangeForPage.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.getInstagramPostsInRangeForPage = (error as Response)
    })
  })
